import React from 'react';
import { useTranslation } from 'react-i18next';

import { PetItem } from './common';

import styles from './RemovedPetsList.module.css';

const RemovedPetsList = ({
  removedPets = [],
  removedPetsCounts = {},
}) => {
  const { t } = useTranslation('petDemos');

  if (!removedPets || removedPets.length === 0) {
    return (
      <span className={styles.policyPetsStatusValue}>
        {t('policyInformation.none')}
      </span>
    );
  }

  const countText = [];
  if (removedPetsCounts.cats > 0) {
    countText.push(t('policyInformation.cats', {
      count: removedPetsCounts.cats,
    }));
  }

  if (removedPetsCounts.dogs > 0) {
    countText.push(t('policyInformation.dogs', {
      count: removedPetsCounts.dogs,
    }));
  }

  return (
    <div className={styles.policyPetsStatusValueList}>
      <span className={styles.policyPetsStatusValue}>
        {countText.join(', ')}
      </span>

      {removedPets.map((pet) => (
        <PetItem
          key={`removed-${pet.Id}`}
          isRemoved
          label={pet.Name}
          specie={pet.Specie}
        />
      ))}
    </div>
  );
};

export { RemovedPetsList };
